import React from 'react';

const SvgKr = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="KR_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <circle id="KR_svg__c" cx={4.667} cy={4.667} r={4.667} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="KR_svg__b" fill="#fff">
        <use xlinkHref="#KR_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <g mask="url(#KR_svg__b)">
        <g transform="translate(9.333 5.333)">
          <mask id="KR_svg__d" fill="#fff">
            <use xlinkHref="#KR_svg__c" />
          </mask>
          <use fill="#E01B41" xlinkHref="#KR_svg__c" />
          <path
            d="M0 5.333c1.333 1.25 3.333 2 4.667 0 1.333-2 4-2 4.666 0 .667 2 0 4 0 4H0s-1.333-5.25 0-4z"
            fill="#0E4B9C"
            mask="url(#KR_svg__d)"
          />
        </g>
      </g>
      <path
        d="M18.944 5.23a.334.334 0 0 1 .12-.464l.573-.33a.338.338 0 0 1 .462.127l1.659 2.874a.334.334 0 0 1-.121.463l-.572.33a.338.338 0 0 1-.462-.127L18.944 5.23zm1.732-1a.334.334 0 0 1 .12-.464l.573-.33a.338.338 0 0 1 .462.127l1.659 2.874a.334.334 0 0 1-.121.463l-.572.33a.338.338 0 0 1-.462-.127L20.676 4.23zM4.51 13.563a.334.334 0 0 1 .121-.463l.572-.33a.338.338 0 0 1 .462.127l1.659 2.873a.334.334 0 0 1-.12.464l-.573.33a.338.338 0 0 1-.462-.127L4.51 13.563zm1.732-1a.334.334 0 0 1 .121-.463l.572-.33a.338.338 0 0 1 .462.127l1.659 2.873a.334.334 0 0 1-.12.464l-.573.33a.338.338 0 0 1-.462-.127l-1.659-2.874zm14.361-.666a.334.334 0 0 1 .462-.127l.572.33c.16.093.215.3.12.463L20.1 15.437a.334.334 0 0 1-.462.127l-.572-.33a.338.338 0 0 1-.121-.464l1.659-2.873zm1.732 1a.334.334 0 0 1 .462-.127l.572.33c.16.093.215.3.12.463l-1.658 2.874a.334.334 0 0 1-.462.127l-.572-.33a.338.338 0 0 1-.12-.464l1.658-2.873zM6.169 3.563a.334.334 0 0 1 .462-.127l.572.33c.161.093.215.3.12.464L5.666 7.103a.334.334 0 0 1-.462.127l-.572-.33a.338.338 0 0 1-.12-.463l1.658-2.874zm1.732 1a.334.334 0 0 1 .462-.127l.572.33c.161.093.216.3.121.464L7.397 8.103a.334.334 0 0 1-.462.127l-.572-.33a.338.338 0 0 1-.12-.463L7.9 4.563z"
        fill="#262626"
        opacity={0.75}
        mask="url(#KR_svg__b)"
      />
    </g>
  </svg>
);

export default SvgKr;
